const imageArchiveDanish = {
  title: "Billedearkiv",
  description: "Upload og administrer dine billeder til LinkedIn opslag. Billederne vil automatisk blive uploadet til Telegram for at gøre dem klar til brug i dine opslag.",
  customerBanner: {
    working: "Du administrerer nu billeder for"
  },
  upload: {
    title: "Upload billeder",
    dragDrop: "Træk og slip billeder her eller klik for at vælge filer",
    selectFiles: "Vælg filer",
    uploadButton: "Upload {count} {count, plural, one {billede} other {billeder}}",
    uploading: "Uploader..."
  },
  gallery: {
    title: "Billedearkiv",
    empty: "Du har ingen billeder uploadet endnu.",
    deleteConfirm: "Er du sikker på, at du vil slette billedet \"{name}\"?",
    noImages: "Ingen billeder fundet"
  },
  notification: {
    uploadSuccess: "{count} {count, plural, one {billede uploadet} other {billeder uploadet}} succesfuldt!",
    uploadTelegramSuccess: "Billede uploadet til Telegram og klar til brug i dine opslag",
    uploadTelegramFail: "Billede gemt, men kunne ikke uploades til Telegram",
    deleteFail: "Der opstod en fejl ved sletning af billedet.",
    deleteSuccess: "Billede slettet!",
    copySuccess: "Billede-URL kopieret til udklipsholder!",
    copyFail: "Kunne ikke kopiere URL.",
    generalError: "Der opstod en fejl. Prøv igen senere."
  },
  messages: {
    onlyImageFiles: "Kun billedfiler er tilladt.",
    noValidUserId: "Kunne ikke finde gyldig bruger-ID."
  }
};

export default imageArchiveDanish; 